{
  "audit_month_human": "May 2026",
  "bills_url": "https://dev.hearthfire.ai/bills",
  "change_count": "2",
  "household_name": "Andre's household",
  "threshold_human": "5%",
  "changes": [
    {
      "name": "Spotify Family",
      "payee": "Spotify",
      "prior_amount_human": "$16.99",
      "new_amount_human": "$19.99",
      "delta_human": "+$3.00",
      "delta_pct_human": "+17.7%",
      "delta_color": "amber",
      "single": false
    },
    {
      "name": "Netflix Premium",
      "payee": "Netflix",
      "prior_amount_human": "$22.99",
      "new_amount_human": "$24.99",
      "delta_human": "+$2.00",
      "delta_pct_human": "+8.7%",
      "delta_color": "amber",
      "single": false
    }
  ]
}
